import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useAppDispatch as useDispatch, useAppSelector as useSelector } from 'dux/app/hooks';

import { productsCategories, productsSlugs } from 'constants/products';

import LoadingScene from 'Scenes/LoadingScene';

import * as accountCardsActions from 'dux/accountCards/actions';
import * as checkoutActions from 'dux/checkout/actions';
import * as featureFlagsSelectors from 'dux/featureFlags/selectors';
import { fetchHairProfileProductVariantBySlug } from 'dux/consultation/thunks';

import { useCheckoutCategory } from '../hooks/useCheckoutCategory';

const CheckoutIdleScene = ({ params }) => {
  const dispatch = useDispatch();
  const isFlagsDoneFetching = useSelector(featureFlagsSelectors.isFlagsDoneFetching);
  const checkoutCategory = useCheckoutCategory();

  // On the idle scene, load checkout data
  useEffect(() => {
    if (isFlagsDoneFetching) {
      dispatch(checkoutActions.loadCheckout(params, checkoutCategory));
      dispatch(accountCardsActions.fetchAccountCards());
    }
  }, [params, isFlagsDoneFetching]);

  useEffect(() => {
    if (isFlagsDoneFetching && checkoutCategory === productsCategories.HAIRCARE) {
      dispatch(fetchHairProfileProductVariantBySlug(productsSlugs.LEAVEIN_CONDITIONER));
    }
  }, [checkoutCategory, isFlagsDoneFetching]);

  // Render the loading scene
  return <LoadingScene />;
};

CheckoutIdleScene.propTypes = {
  params: PropTypes.shape({}).isRequired,
};

export default CheckoutIdleScene;
